import { useEffect } from "react";
import { useRoutes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AppRoutes from "./routes/AppRoutes";
import { useSessionTimeout } from "@/hooks/useSessionTimeout";

const App = () => {
  // HIPAA-compliant 15-minute inactivity auto-logout
  useSessionTimeout();

  useEffect(() => {
    // App initialized
  }, []);

  const routing = useRoutes(AppRoutes);

  return (
    <>
      {routing}
      <Toaster position="top-right" expand={true} />
    </>
  );
};

export default App;
